import { render, staticRenderFns } from "./Cm-section-head.vue?vue&type=template&id=062556bc"
import script from "./Cm-section-head.vue?vue&type=script&lang=js"
export * from "./Cm-section-head.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports